import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import _ from "lodash";
import { SearchOutlined } from "@ant-design/icons";

import { Table, Input, Button, Popconfirm, Tag } from "antd";
import Highlighter from "react-highlight-words";

import Breadcrumb from "../../components/Breadcrumb";

import CreateForm from "../../components/HotelsGroups/HotelsGroupsManager/CreateForm";
import UpdateForm from "../../components/HotelsGroups/HotelsGroupsManager/UpdateForm";
import ExportCSV from "../../components/Common/ExportCSV";

// const data = this.props.api.userGetData;

class HotelsGroupsManager extends Component {
  state = {
    searchText: "",
    searchedColumn: "",
    loading: false,
    visible: false,
    createModalVisible: false,
    updateModalVisible: false,
    updateInitialValue: null,
  };
  async componentDidMount() {
    if (!this.props.api.hotelsGroupsGetData) {
      await this.props.hotelsGroupsGet();
    }

    // if (!this.props.api.mainRolesGetData) {
    //   await this.props.mainRolesGet();
    // }
  }

  getColumnSearchProps = (dataIndex, type, isSearchIndexs) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          // placeholder={`Search ${dataIndex}`}
          placeholder="Search"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{
            width: 90,
            marginRight: 8,
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),

    onFilter: (value, record) => {
      if (type == "array") {
        if (record[dataIndex]) {
          let rValue = false;
          record[dataIndex].forEach((d) => {
            if (
              d.hotel_name
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()) ||
              d.hotel_code
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            ) {
              rValue = true;
            }
          });
          return rValue;
          // return record.hotels.hotel_name.toString().toLowerCase().includes(value.toLowerCase())
        } else {
          return false;
        }
      } else if (type == "multiple") {
        if (record[dataIndex]) {
          var rValue = false;
          isSearchIndexs.forEach((element) => {
            if (
              record[element] &&
              record[element]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            ) {
              rValue = true;
            }
          });
          return rValue;
        } else {
          return false;
        }
      } else {
        if (record[dataIndex]) {
          return record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        } else {
          return false;
        }
      }
    },

    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex && text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    this.setState({ searchText: "" });
  };

  createModalShow = () => {
    this.setState({ createModalVisible: true });
  };

  createModalCancel = () => {
    this.setState({ createModalVisible: false });
  };

  createModalCreate = () => {
    const { form } = this.createModalFormRef.props;
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      // const qqqq = await this.props.userCreate(values);

      if (await this.props.mainRoleCreate(values)) {
        form.resetFields();
        await this.props.mainRolesGet();
        this.setState({ createModalVisible: false });
      }
    });
  };

  createModalFormRefSaveFormRef = (formRef) => {
    this.createModalFormRef = formRef;
  };

  handleEdit = (data) => {
    this.setState({ updateModalVisible: true, updateInitialValue: data });
  };

  updateModalShow = (data) => {
    this.setState({ updateModalVisible: true, updateInitialValue: data });
  };

  updateModalCancel = () => {
    const { form } = this.updateModalFormRef.props;
    form.resetFields();
    this.setState({ updateModalVisible: false, updateInitialValue: null });
  };

  updateModalCreate = () => {
    const { form } = this.updateModalFormRef.props;
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      // const qqqq = await this.props.userCreate(values);

      if (await this.props.mainRoleUpdate(values)) {
        form.resetFields();
        await this.props.mainRolesGet();
        this.setState({ updateModalVisible: false });
      }
    });
  };

  updateModalFormRefSaveFormRef = (formRef) => {
    this.updateModalFormRef = formRef;
  };
  getUpdatedExcelBuffer = (hotelGrpMgr) => {
    return _.cloneDeep(hotelGrpMgr).map((i) => {
      i.hotels = i.hotels
        .map((hotel) => {
          return hotel.hotel_code + " - " + hotel.hotel_name;
        })
        .join();
      return i;
    });
  };
  render() {
    const columns = [
      {
        title: "Hotel Group Name",
        dataIndex: "hotel_group_name",
        key: "hotel_group_name",
        fixed: "left",
        width: "250px",
        ...this.getColumnSearchProps("hotel_group_name"),
        sorter: (a, b) =>
          a.hotel_group_name
            ? a.hotel_group_name.localeCompare(b.hotel_group_name)
            : null,
      },
      {
        title: "ID",
        dataIndex: "_id",
        key: "_id",
        width: "250px",
        ...this.getColumnSearchProps("_id"),
      },
      {
        title: "HMG Name",
        dataIndex: "hmg_name",
        key: "hmg_name",

        width: "400px",
        ...this.getColumnSearchProps("hmg_name", "multiple", [
          "hmg_name",
          "project_name",
        ]),
        sorter: (a, b) =>
          a.hmg_name ? a.hmg_name.localeCompare(b.hmg_name) : null,
        render: (text, record) =>
          text ? (
            <span>
              {text} - {record.project_name}
            </span>
          ) : null,
      },
      {
        title: "Hotels",
        dataIndex: "hotels",
        key: "hotels",
        width: "500px",
        ...this.getColumnSearchProps("hotels", "array", [
          "hotel_code",
          "hotel_name",
        ]),
        render: (hotels) => (
          <span>
            {hotels.map((hotel) => (
              <div key={hotel._id}>
                {hotel.hotel_code} - {hotel.hotel_name}
              </div>
            ))}
          </span>
        ),
      },

      {
        title: "Created by",
        dataIndex: "create_by",
        key: "create_by",
        width: "200px",
        ...this.getColumnSearchProps("create_by"),
      },
      {
        title: "Created at",
        dataIndex: "create_at",
        key: "create_at",
        width: "200px",
        ...this.getColumnSearchProps("create_at"),
      },
      {
        title: "Updated by",
        dataIndex: "update_by",
        key: "update_by",
        width: "200px",
        ...this.getColumnSearchProps("update_by"),
      },
      {
        title: "Updated at",
        dataIndex: "update_at",
        key: "update_at",
        width: "200px",
        ...this.getColumnSearchProps("update_at"),
      },

      // {
      //   title: "Action",
      //   dataIndex: "action",
      //   fixed: "right",
      //   width: "100px",
      //   render: (text, record) => (
      //     <Popconfirm
      //       title="Sure to edit?"
      //       onConfirm={() => this.updateModalShow(record)}
      //     >
      //       <a href="/#">Edit</a>
      //     </Popconfirm>
      //   )
      // }
    ];

    let tableHeight = 500;
    if (window.innerWidth > 700) {
      tableHeight = window.innerHeight - 300;
    }

    return (
      <div>
        <div className="container_aa">
          <h3>Hotels Groups Manager</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              {
                path: "hotels-groups-manager",
                breadcrumbName: "Hotels Groups Manager",
              },
            ]}
          />
        </div>

        <div className="container_ab">
          <div className="container_style_1 user_manager">
            {/* <div className="container_style_1_a">
              <Button type="primary" onClick={this.createModalShow}>
                Create Main Role
              </Button>
            </div> */}
            <div className="container_style_1_b" style={{ width: "100%" }}>
              {this.props.api.hotelsGroupsGetData ? (
                <div className="is_table_3 a01">
                  <ExportCSV
                    csvData={this.getUpdatedExcelBuffer(
                      this.props.api.hotelsGroupsGetData.data
                    )}
                    fileName={"HotelGroupManager"}
                    columnNames={columns}
                  />
                  <Table
                    className={"sm-custom-column-header"}
                    columns={columns}
                    scroll={{ x: 1950, y: tableHeight }}
                    dataSource={this.props.api.hotelsGroupsGetData.data}
                    rowKey="_id"
                    size="default"
                  />
                </div>
              ) : null}

              {/* <CreateForm
                wrappedComponentRef={this.createModalFormRefSaveFormRef}
                visible={this.state.createModalVisible}
                onCancel={this.createModalCancel}
                onCreate={this.createModalCreate}

              /> */}

              {/* <UpdateForm
                wrappedComponentRef={this.updateModalFormRefSaveFormRef}
                visible={this.state.updateModalVisible}
                onCancel={this.updateModalCancel}
                onCreate={this.updateModalCreate}
                updateInitialValue={this.state.updateInitialValue}

              /> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hotelsGroupsGet: () => dispatch(actions.hotelsGroupsGet()),

  mainRoleCreate: (data) => dispatch(actions.mainRoleCreate(data)),
  mainRoleUpdate: (data) => dispatch(actions.mainRoleUpdate(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HotelsGroupsManager);
